import { render, staticRenderFns } from "./FormClass.vue?vue&type=template&id=20817dcb&"
import script from "./FormClass.vue?vue&type=script&lang=js&"
export * from "./FormClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports